function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaddingNotselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14445"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5521",
    style: {
      fill: "#f3f3f3",
      stroke: "#ebebeb"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13604"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13600"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1938",
    style: {
      stroke: "#252529",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h12v12H0z",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h11v11H.5z",
    transform: "translate(6 6)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1939",
    transform: "translate(8 8)",
    style: {
      fill: "#bdbdbd"
    },
    d: "M0 0h8v8H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingNotselected);
export default __webpack_public_path__ + "static/media/PaddingNotselected.cdc9b935118ff64a862930c858bbeb62.svg";
export { ForwardRef as ReactComponent };